import AbstractProvidedClass from "../shared/AbstractProvidedClass";
import { DEFAULT_OPACITY } from "../shared/constants";

export default class Appearance extends AbstractProvidedClass {
    constructor(provider, data = {}) {
        super(provider);
        this.fillColor = data.fillColor ?? null;
        this.strokeColor = data.strokeColor ?? null;
        this.strokeWidth = data.strokeWidth ?? null;
    }

    apply(hovered, selected, flash, opacity = DEFAULT_OPACITY) {
        if (this.fillColor) {
            this.fillColor.setAlpha(opacity);
            this.p.fill(this.fillColor);
        } else {
            this.p.noFill();
        }
        if (flash) {
            this.p.stroke(200, 0, 150);
            this.p.strokeWeight(this.p.max(3, this.strokeWidth));
        } else if (hovered) {
            this.p.stroke(255, 255, 0);
            this.p.strokeWeight(this.p.max(3, this.strokeWidth));
        } else if (selected) {
            this.p.stroke(255, 130, 0);
            this.p.strokeWeight(this.p.max(3, this.strokeWidth));
        } else if (this.strokeColor && this.strokeWidth) {
            this.p.stroke(this.strokeColor);
            this.p.strokeWeight(this.strokeWidth);
        } else if (this.strokeColor) {
            this.p.stroke(this.strokeColor);
            this.p.strokeWeight(1);
        } else {
            this.p.noStroke();
        }
    }

    applyToSvg(svg) {
        svg.fill(
            this.fillColor
                ? { color: this.fillColor.toString(), opacity: DEFAULT_OPACITY / 255 }
                : 'none'
        );
        svg.stroke({
            color: this.strokeColor ? this.strokeColor.toString() : 'none',
            width: this.strokeWidth ? this.strokeWidth : 'none',
        });
    }

    clone() {
        this.fillColor ? this.fillColor.setAlpha(255) : null;
        return new Appearance(
            this.provider,
            {
                fillColor: this.fillColor ? this.p.color(this.fillColor.toString()) : null,
                strokeColor: this.strokeColor ? this.p.color(this.strokeColor.toString()) : null,
                strokeWidth: this.strokeWidth
            }
        );
    }

    export() {
        this.fillColor ? this.fillColor.setAlpha(255) : null;
        return {
            fillColor: this.fillColor ? this.fillColor.toString() : null,
            strokeColor: this.strokeColor ? this.strokeColor.toString() : null,
            strokeWidth: this.strokeWidth ? this.strokeWidth : null,
        }
    }
}
